import { compose, lifecycle, pure, withState } from "recompose";

import AutoCompleteInput from "../../elements/FormBuilder/AutoCompleteInput";
import Queries from "../../queries/queries2";
import React from "react";
import { graphql } from "react-apollo";

const componentState = withState("options", "setOptions", []);
const inputValue = withState("value", "setValue", "");

const data = graphql(Queries.GET_TAG_ARTICLES, {
  options: ({ companyId }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: { companyId }
    };
  }
});

const componentLifecycle = lifecycle({
  componentDidMount() {
    let tags = [];
    let newOptions = [];
    // gets all company's tagArticle
    this.props.data.tagArticles &&
      this.props.data.tagArticles.map(article => {
        return tags.push(article.tagArticle);
      });
    // removes duplicates from tags and populate newOptions array
    [...new Set(tags)].map(tag => {
      newOptions.push({
        name: tag
      });
      return tag;
    });
    // persists options in component's state
    this.props.setOptions(newOptions);
  }
});

const TagArticleSelectBase = ({ value, options, setValue }) => (
  <AutoCompleteInput value={value} onValueChange={setValue} options={options} />
);

const TagArticleSelect = compose(
  componentState,
  inputValue,
  data,
  pure,
  componentLifecycle
)(TagArticleSelectBase);

export default TagArticleSelect;
